import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

export default function CybersecurityInfo() {
  const { t } = useTranslation();

  return (
    <div>
      <h4>Symantec Cybersecurity</h4>
      <div>
        <h4>{t("network_sec")}</h4>
        <div className={styles.list_default}>
          {t("network_sec_text")}
          <ul>
            <li key="1">{t("network_li_1")}</li>
            <li key="2">{t("network_li_2")}</li>
            <li key="3">{t("network_li_3")}</li>
            <li key="4">{t("network_li_4")}y</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("education")}</h4>
        <div className={styles.list_default}>
          {t("education_text")}
          <ul>
            <li key="1">{t("educ_1")}</li>
            <li key="2">{t("educ_2")}</li>
            <li key="3">{t("educ_3")}</li>
            <li key="4">{t("educ_4")}</li>
            <li key="5">{t("educ_5")}</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("info_sec")}</h4>
        <div className={styles.list_default}>
          {t("info_text")}
          <ul>
            <li key="1">{t("info_1")}</li>
            <li key="2">{t("info_2")}</li>
            <li key="3">{t("info_3")}</li>
            <li key="4">{t("info_4")}</li>
            <li key="5">{t("info_5")}</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("endpoint_sec")}</h4>
        <div className={styles.list_default}>
          {t("endpoint_text")}
          <ul>
            <li key="1">{t("endpoint_1")}</li>
            <li key="2">{t("endpoint_2")}</li>
            <li key="3">{t("endpoint_3")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
